import { render, staticRenderFns } from "./InputDashboard.vue?vue&type=template&id=3e7867a0&scoped=true"
import script from "./InputDashboard.vue?vue&type=script&lang=js"
export * from "./InputDashboard.vue?vue&type=script&lang=js"
import style0 from "./InputDashboard.vue?vue&type=style&index=0&id=3e7867a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7867a0",
  null
  
)

export default component.exports